import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsPanel = ({ stats }) => {
  const statItems = [
    {
      id: 'total',
      title: 'کل درخواست‌ها',
      value: stats?.totalRequests,
      icon: 'FileText',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      id: 'pending',
      title: 'در حال بررسی',
      value: stats?.pendingRequests,
      icon: 'Clock',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
    },
    {
      id: 'completed',
      title: 'تکمیل شده',
      value: stats?.completedRequests,
      icon: 'CheckCircle',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      id: 'credits',
      title: 'اعتبار مصرفی امروز',
      value: stats?.creditsUsedToday,
      icon: 'Coins',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statItems?.map((item) => (
        <div
          key={item?.id}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow duration-150">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">
                {item?.title}
              </p>
              <p className="text-2xl font-bold text-foreground">
                {item?.value}
              </p>
            </div>
            <div
              className={`w-12 h-12 ${item?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={item?.icon} size={24} className={item?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsPanel;
